<div class="dialogTitle">
  <h2>
    {{ (data.single ? "organisations.select.title.single" : "organisations.select.title.multi") | translate }}
  </h2>
</div>
<mat-dialog-content>
  <mat-form-field class="searchField" appearance="outline">
    <input
      matInput
      autocomplete="off"
      type="text"
      placeholder="Search by name"
      [(ngModel)]="search"
    />
  </mat-form-field>
  <div
    class="flex flex-col"
    *ngIf="
      (data.organisations | async | keyvalue)?.length > 0;
      else noOrganisations
    "
  >
    <div
      matRipple
      class="item flex flex-row justify-start items-center"
      *ngFor="
        let row of data.organisations
          | async
          | keyvalue
          | organisationSortPipe
          | organisationFilterPipe : search
      "
      [class.selected]="selectedIds?.includes(row.key)"
      (click)="toggle(row.value)"
    >
      <div class="avatar">
        <ca-avatar [fullName]="row.value.name" [fontSize]="15"> </ca-avatar>
      </div>
      <div class="organisation-name">
        <h3>{{ row.value.name }}</h3>
      </div>
    </div>
  </div>
  <ng-template #noOrganisations>
    <p>
      {{ "organisations.select.empty" | translate }}
    </p>
  </ng-template>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="dialogOptions">
    <button
      color="primary"
      [disabled]="!selectedIds.length"
      mat-flat-button
      [mat-dialog-close]="selectedIds"
    >
      {{ "organisations.select.done" | translate }}
    </button>

    <!-- Select all/none only available with multi-select -->
    <ng-container *ngIf="!data.single && data.organisations | async as orgs">
      <button
        *ngIf="selectedIds.length < (orgs | keyvalue).length"
        mat-button
        (click)="selectOrgs(orgs)"
      >
        {{ "organisations.select.all" | translate }}
      </button>
      <button
        *ngIf="selectedIds.length === (orgs | keyvalue).length"
        mat-button
        (click)="selectOrgs({})"
      >
        {{ "organisations.select.none" | translate }}
      </button>
    </ng-container>
  </div>
</mat-dialog-actions>
